// Season/episode stepper for manually setting where you are in a show --
// the fallback when detection missed it or got it wrong. Shared by Hub and
// Watchlist. `positioning` is { season, episode, ... }; onChange receives a
// functional updater, same as a useState setter.
export default function EpisodePicker({ positioning, onChange, onSave, onCancel }) {
  const step = (field, delta) => onChange(prev => ({ ...prev, [field]: Math.max(1, (prev[field] ?? 1) + delta) }));
  const btn = "w-8 h-8 rounded-full border border-white/15 text-neutral-300 flex items-center justify-center text-lg hover:border-white/40 hover:text-white select-none";
  return (
    <div className="mt-3 pt-3 border-t border-white/10">
      <div className="flex items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-xs text-neutral-500 w-14">Season</span>
          <button className={btn} onClick={() => step('season', -1)}>−</button>
          <span className="w-7 text-center text-sm font-bold text-white">{positioning.season}</span>
          <button className={btn} onClick={() => step('season', 1)}>+</button>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-neutral-500 w-14">Episode</span>
          <button className={btn} onClick={() => step('episode', -1)}>−</button>
          <span className="w-7 text-center text-sm font-bold text-white">{positioning.episode}</span>
          <button className={btn} onClick={() => step('episode', 1)}>+</button>
        </div>
      </div>
      <div className="flex gap-2">
        <button className="px-4 py-2 rounded-full text-sm font-bold text-white" style={{ background: 'linear-gradient(135deg,#7c3aed,#4A9EFF)' }} onClick={onSave}>Save</button>
        <button className="px-4 py-2 rounded-full text-sm text-neutral-400 border border-white/10 hover:border-white/20" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
